export default __webpack_public_path__ + "static/media/uulzalt2.d6792c3a.png";